import React from 'react';
import { Typography, Divider, Box } from '@mui/material';
import { sa } from '../superAdminUi';

// Consistent section header for the Group/School add/edit forms: a title (optional
// subtitle) above a divider, on the Super Admin design tokens. Render inside a full-width Grid item.
export default function FormSectionHeader({ title, subtitle, first = false }) {
  return (
    <Box sx={{ mt: first ? 0 : 2 }}>
      <Typography sx={{ fontFamily: sa.font.family, fontWeight: sa.font.bold, fontSize: 15, color: sa.color.text }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography sx={{ fontFamily: sa.font.family, fontSize: 13, color: sa.color.textGray, mt: 0.25 }}>
          {subtitle}
        </Typography>
      )}
      <Divider sx={{ mt: 1, mb: 0.5, borderColor: sa.color.stroke }} />
    </Box>
  );
}
